import { useEffect } from 'react';

import { useTableViewHelpers } from '@design-system/molecules/ticlick-table/hooks/use-table-view-helpers';
import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { leadEnrollmentStatusFilterConfig } from '../../../configs/lead-enrollment-status-filter-config';
import { programFilterConfig } from '../../../configs/program-filter-config';
import { entityFilterIds } from '../../../helpers/filter-none';

export const LeadEnrollmentStatusFilter = () => {
  const { clearMultipleFacets, getSelectedStaticFilterFacet } =
    useTableViewHelpers();

  const programFacet = getSelectedStaticFilterFacet(
    programFilterConfig.facetName
  );
  const hasProgram = entityFilterIds(programFacet?.value ?? []).length > 0;

  useEffect(() => {
    if (hasProgram) return;

    const enrollmentFacet = getSelectedStaticFilterFacet(
      leadEnrollmentStatusFilterConfig.facetName
    );
    if (!enrollmentFacet) return;

    clearMultipleFacets([leadEnrollmentStatusFilterConfig.facetName]);
  }, [clearMultipleFacets, getSelectedStaticFilterFacet, hasProgram]);

  return (
    <InputFilterTrigger
      filterLabel='Enrollment status'
      config={leadEnrollmentStatusFilterConfig}
      disabled={!hasProgram}
      hint={hasProgram ? undefined : 'Select a program first'}
    />
  );
};
